fx.translations("en",{
    "Sauvegarde de votre mise en page ..." : "Saving your layout...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "HEIC images must be fully uploaded to be used for automatic creation."
});

